import { render, staticRenderFns } from "./InstructorRoster.vue?vue&type=template&id=7c5c2058&scoped=true"
import script from "./InstructorRoster.vue?vue&type=script&lang=js"
export * from "./InstructorRoster.vue?vue&type=script&lang=js"
import style0 from "./InstructorRoster.vue?vue&type=style&index=0&id=7c5c2058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5c2058",
  null
  
)

export default component.exports